import { T } from 'gt-react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { InboundEmailViewer } from '@/components/email-viewer/InboundEmailViewer';

interface Props {
  inboundEmailId: string | null;
  onClose: () => void;
}

/**
 * Side sheet that shows an inbound email linked to a collection thread using
 * the canonical SmartEmailViewer (via InboundEmailViewer).
 */
export function InboundEmailDetailSheet({ inboundEmailId, onClose }: Props) {
  const isOpen = !!inboundEmailId;
  return (
    <Sheet open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <SheetContent
        side="right"
        className="w-full sm:max-w-2xl overflow-hidden flex flex-col p-0"
      >
        <SheetHeader className="px-4 py-3 border-b">
          <SheetTitle className="text-sm">
            <T context="sheet title, inbound email detail">Email</T>
          </SheetTitle>
        </SheetHeader>
        <div className="flex-1 min-h-0 overflow-hidden">
          {inboundEmailId && (
            <InboundEmailViewer inboundEmailId={inboundEmailId} />
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
